import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import BestWrestler from '../../../pages/BestWrestler';
import BestWrestlerMobile from '../../../pages/Mobile/Stats/BestWrestlerMobile';

const BestWrestlerResponsive = () => {
    const { isMobile } = useResponsiveRedux(); 
    return isMobile ? <BestWrestlerMobile /> : <BestWrestler />;
}; 

export default BestWrestlerResponsive;